export const shortDayFormat = 'ddd';
export const shortMonth = 'MMM';
export const shortDateFormat = 'D MMM';
export const shortDayDateFormat = 'ddd, D MMM';
export const timeFormat = 'h:mmA';
export const datetimeFormat = `ddd, D MMM · ${timeFormat}`;
